"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientReportHeader = void 0;
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("../../../../../../../../../../client/modules/reporting/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const switch_1 = require("client/components/material/switch"); // E-037.4
let PatientReportHeader = class PatientReportHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.siteId = 0;
        this.showDisabledSites = false; // E-037.4
        this.headerToggle = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
        this.handleLoader = () => {
            store_1.reportsStore.showLoader = !store_1.reportsStore.showLoader;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            await store_1.reportsStore.loadPatientReports(this.siteId, true);
        };
        this.handleCancel = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
        // E-037.4
        this.handleShowDisabledSitesToggle = async () => {
            this.showDisabledSites = !this.showDisabledSites;
            if (this.showDisabledSites) {
                await store_2.sitesListStore.loadDeletedSites();
            }
            else {
                await store_2.sitesListStore.loadSitesNoRelation();
            }
        };
    }
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString(),
                        live: site.live // C-123
                    });
                });
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString(),
                live: site.live // C-123
            };
            options.push(siteOption);
        }
        return options;
    }
    componentWillMount() {
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.siteId = store_3.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            store_2.sitesListStore.loadSitesNoRelation();
        }
    }
    render() {
        const { title } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Search Options")),
            store_1.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, top: "25%", width: "480px" // E-037.2
                , buttons: buttons, overflowY: true },
                React.createElement(switch_1.MaterialSwitch, { label: "Show Disabled Sites", value: "showDisabledSites", checked: this.showDisabledSites, onChange: this.handleShowDisabledSitesToggle }),
                React.createElement("div", { className: "filter-bar" },
                    React.createElement(select_1.MaterialSelect, { showDisabledSites: this.showDisabledSites, backgroundColor: true, options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "", width: "100%" })))) : null,
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.observable
], PatientReportHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], PatientReportHeader.prototype, "showDisabledSites", void 0);
__decorate([
    mobx_1.computed
], PatientReportHeader.prototype, "availableOptions", null);
PatientReportHeader = __decorate([
    mobx_react_1.observer
], PatientReportHeader);
exports.PatientReportHeader = PatientReportHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/patients-report/components/patient-header/patients-report-header.tsx
// module id = 3991
// module chunks = 0